import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Form, Input } from "antd";
import styles from "./Auth.module.css";
import { userLogin } from "../../utils";
import { useSession } from "../../session/SessionContext";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

const destination = (from) =>
  from ? `${from.pathname}${from.search ?? ""}${from.hash ?? ""}` : "/";

const Auth = () => {
  const { user, signIn } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);
  const [formError, setFormError] = useState(null);
  const next = destination(location.state?.from);

  if (user) {
    return <Navigate to={next} replace />;
  }

  const handleSubmit = async ({ email, password }) => {
    setSubmitting(true);
    setFormError(null);
    try {
      const { token } = await userLogin(email, password);
      await signIn(token);
      navigate(next, { replace: true });
    } catch (error) {
      setFormError(error.message || "Something went wrong. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <div className={styles.authWrapper}>
      <div className={styles.authCard}>
        <div className={styles.authLogo}>Brixture</div>
        <Card>
          <Form {...layout} onFinish={handleSubmit}>
            <Form.Item
              label="Email"
              name="email"
              rules={[{ required: true, message: "Email is required" }]}
            >
              <Input autoComplete="username" />
            </Form.Item>
            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: "Password is required" }]}
            >
              <Input.Password autoComplete="current-password" />
            </Form.Item>

            {formError && <div className={styles.formError}>{formError}</div>}

            <Form.Item {...tailLayout}>
              <Button type="primary" htmlType="submit" loading={submitting}>
                Sign in
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </div>
    </div>
  );
};

export default Auth;
